import React from 'react';
import lodash from 'lodash-es';
import deepdash from 'deepdash-es';
import classNames from 'classnames';
import NavList from './NavList';
import NavItem from './NavItem';
import Anime from '../common/Anime';
import Icon from '../common/Icon';

const _ = deepdash(lodash);

const Pane = ({ translateX, duration = 300, ...props }) => (
  <Anime
    {...props}
    className="nav__pane"
    animation={{
      easing: 'easeOutCubic',
      translateX,
      duration,
    }}
  />
);

const BackButton = ({ visible, ...props }) => (
  <button
    {...props}
    type="button"
    className={classNames(
      'button',
      '-flat',
      'nav__itemButton',
      '-reverseBorder',
      {
        '-visible': visible,
      },
    )}
  >
    <Icon name="chevron-left-regular" />
  </button>
);

const NavigationPanes = ({
  items,
  paneLevel,
  isAdmin,
  adminPage,
  activeItem,
  activeItemLvl2,
  isPaneLevel,
  setActiveItem,
  setPaneLevel,
  skipAnimate,
}) => {
  const mainItems = Object.keys(items).map(key => (
    <NavItem
      {...items[key]}
      key={items[key].id}
      buttonClickHandler={() => {
        setPaneLevel(1);
        setActiveItem(items[key].id);
      }}
    />
  ));

  const adminLink =
    isAdmin === true
      ?
      <NavItem
        nested={false}
        link={adminPage}
        title="Admin"
        hideChildren
      />
      : ''

  const secondLevelItems =
    activeItem && activeItem.level === 1
      ? activeItem.children.map(({ id, ...props }) => (
        <NavItem
          {...props}
          key={id}
          buttonClickHandler={() => {
            setPaneLevel(2);
            setActiveItem(id);
          }}
          nested
        />
      ))
      : [];

  const backButton = () => (
    <BackButton
      visible={!!paneLevel}
      onClick={() => {
        setPaneLevel(paneLevel - 1);
        setActiveItem(null);
      }}
    />
  );

  return (
    <div className="nav__panes">
      <Pane
        in={!isPaneLevel(0)}
        skipAnimate={skipAnimate}
        translateX={[0, '-40%']}
      >
        <NavList>
          {mainItems}
          {adminLink}
        </NavList>
      </Pane>
      <Pane
        in={!!isPaneLevel(1) || !!isPaneLevel(2)}
        skipAnimate={skipAnimate}
        translateX={[0, '-100%']}
      >
        {activeItem && activeItem.children && (
          <NavList>
            <NavItem
              nested={false}
              link="/"
              title="Start"
              active
              hideChildren
              before={backButton}
            />
            <NavItem {...activeItem} hideChildren className="nav__item__current" />
            {secondLevelItems}
          </NavList>
        )}
      </Pane>
      <Pane
        in={!!isPaneLevel(2)}
        skipAnimate={skipAnimate}
        translateX={['-100%', '-200%']}
      >
        {activeItemLvl2 && activeItemLvl2.children && (
          <NavList>
            <NavItem {...activeItem} hideChildren before={backButton} />
            <NavItem {...activeItemLvl2} hideChildren className="nav__item__current" />
            {activeItemLvl2.children.map(({ id, ...props }) => (
              <NavItem
                {...props}
                key={id}
                buttonClickHandler={() => {
                  setPaneLevel(3);
                  setActiveItem(id);
                }}
                nested
              />
            ))}
          </NavList>
        )}
      </Pane>
    </div>
  );
};

export default NavigationPanes;